import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Resolve stored image paths: uploaded files are stored as "/api/files/..." (relative, deploy-safe),
// external images are absolute http(s) URLs.
export const resolveImg = (src) => {
  if (!src) return "";
  if (src.startsWith("http://") || src.startsWith("https://")) return src;
  return `${BACKEND_URL}${src}`;
};

export const getExpansions = (params = {}) => api.get("/expansions", { params }).then((r) => r.data);
export const getExpansion = (slug) => api.get(`/expansions/${slug}`).then((r) => r.data);
export const getEras = () => api.get("/eras").then((r) => r.data);
export const getEra = (slug) => api.get(`/eras/${slug}`).then((r) => r.data);
export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getCards = (params = {}) => api.get("/cards", { params }).then((r) => r.data);
export const getCard = (slug) => api.get(`/cards/${slug}`).then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (data) => api.put("/admin/settings", data).then((r) => r.data);
export const validateCart = (items) => api.post("/cart/validate", { items }).then((r) => r.data);

export const createCheckout = (payload) => api.post("/checkout/create", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);
export const getContent = (key) => api.get(`/content/${key}`).then((r) => r.data);
export const getAllContent = () => api.get("/admin/content").then((r) => r.data);
export const updateContent = (key, payload) => api.put(`/admin/content/${key}`, payload).then((r) => r.data);
export const getOrders = () => api.get("/admin/orders").then((r) => r.data);
export const updateOrderStatus = (orderId, fulfillment_status) =>
  api.put(`/admin/orders/${orderId}/status`, { fulfillment_status }).then((r) => r.data);

export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
